// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

html {
    font-size: 16px;
    height: 100%;
}


:root {
    --color-selected-bg: #ccc;
    --color-selected-border: #000;
    --color-selected-hover-bg: #b8b8b8;
    --color-selected-hover-border: #777;
}


* {
    box-sizing: border-box;
}


input, select, textarea {
    font-family: inherit;
}


body {
    margin: 0;
    height: 100%;
    background: #ffffff;
    color: #000;
    font-family: Arial, sans-serif;
}


#root {
    height: 100%;
}


#container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 16px;
    height: 100%;
    display: flex;
    flex-direction: column;
    /* background-color: pink; */
}





/* 
.splash {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 18px;
    color: var(--text);
} */


.splash {
    height: 100vh; /* fallback for older browsers */
    height: 100dvh; /* dynamic viewport height — updates live as browser chrome shows/hides */
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 18px;
    color: var(--text);
}`, "",{"version":3,"sources":["webpack://./code/styles/globals.css"],"names":[],"mappings":";;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;;AAGA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,kCAAkC;IAClC,mCAAmC;AACvC;;;AAGA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,oBAAoB;AACxB;;;AAGA;IACI,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,8BAA8B;AAClC;;;AAGA;IACI,YAAY;AAChB;;;AAGA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,4BAA4B;AAChC;;;;;;AAMA;;;;;;;;;GASG;;;AAGH;IACI,aAAa,EAAE,gCAAgC;IAC/C,cAAc,EAAE,yEAAyE;IACzF,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,eAAe;IACf,kBAAkB;AACtB","sourcesContent":["\n\nhtml {\n    font-size: 16px;\n    height: 100%;\n}\n\n\n:root {\n    --color-selected-bg: #ccc;\n    --color-selected-border: #000;\n    --color-selected-hover-bg: #b8b8b8;\n    --color-selected-hover-border: #777;\n}\n\n\n* {\n    box-sizing: border-box;\n}\n\n\ninput, select, textarea {\n    font-family: inherit;\n}\n\n\nbody {\n    margin: 0;\n    height: 100%;\n    background: #ffffff;\n    color: #000;\n    font-family: Arial, sans-serif;\n}\n\n\n#root {\n    height: 100%;\n}\n\n\n#container {\n    max-width: 1400px;\n    margin: 0 auto;\n    padding: 16px;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    /* background-color: pink; */\n}\n\n\n\n\n\n/* \n.splash {\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    font-size: 18px;\n    color: var(--text);\n} */\n\n\n.splash {\n    height: 100vh; /* fallback for older browsers */\n    height: 100dvh; /* dynamic viewport height — updates live as browser chrome shows/hides */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    font-size: 18px;\n    color: var(--text);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
